import { Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  // State to manage the navbar toggle for mobile view
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  // Function to handle navbar toggle (for mobile view)
  const handleNavbarToggle = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  // Function to handle link click (close the navbar on mobile)
  const handleLinkClick = () => {
    if (isMobile) {
      setIsNavbarOpen(false); // Close the navbar on mobile
    }
  };

  return (
    <div>
      <nav
        id="nav"
        className="navbar navbar-expand-lg navbar-light bg-light sticky-top"
      >
        <Link className="navbar-brand" to="/" onClick={handleLinkClick}>
          Savepenny
        </Link>
        
        {/* Mobile Navbar Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={handleNavbarToggle}
          aria-controls="navbarNav"
          aria-expanded={isNavbarOpen ? "true" : "false"}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Collapse Logic - Always Expanded on Desktop, Collapsing on Mobile */}
        <div
          className={`navbar-collapse ${isNavbarOpen || !isMobile ? "show" : ""}`}
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <li className="nav-item active">
              <Link
                className="nav-link"
                to={`/${location.search}`}
                onClick={handleLinkClick}
              >
                Home <span className="sr-only">(current)</span>
              </Link>
            </li>
            <li className="nav-item active">
              <Link
                className="nav-link"
                to={`/products-list${location.search && `/${location.search}`}`}
                onClick={handleLinkClick}
              >
                Saved Products <span className="sr-only">(current)</span>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
